import React from 'react'
import Image from 'next/image'
import clsx from 'clsx'
import { useTheme, css } from '@emotion/react'
import { Typography } from './'

function Title({
    children,
    className,
    color = 'medGray',
    size = 'lg',
    highlight,
    highlightColor = 'primary',
    imgSrc,
    style
}) {
    const theme = useTheme()
    const sizeSwitch = (titleSize) => {
        const fontSize = theme.fontSize
        switch (titleSize) {
            case 'xs':
                return fontSize.xs
            case 'sm':
                return fontSize.sm
            case 'md':
                return fontSize.base
            case 'lg':
                return fontSize['2xl']
            case 'xl':
                return fontSize['3xl']
            case 'xxl':
                return fontSize['4xl']
        }
    }

    return (
        <div
            className={clsx('flex items-center flex-wrap', className)}
            css={css`
                ${style}
            `}
        >
            <Typography
                className="px-2 flex items-center"
                type="h3"
                fontWeight="Semi Bold"
                color={color}
                transform="uppercase"
                fontSize={sizeSwitch(size)}
            >
                {imgSrc && (
                    <Image
                        alt="forex rebate chart sign"
                        src={imgSrc}
                        width={90}
                        height={40}
                    />
                )}
                <div
                    className="px-1"
                    dangerouslySetInnerHTML={{
                        __html: children?.replace(
                            highlight,
                            `<span style = "color: ${theme.colors[highlightColor]}; text-decoration: underline;">${highlight}</span>`
                        )
                    }}
                />
            </Typography>
        </div>
    )
}

export default Title
